import { Box } from '@mui/material'
import { FC } from 'react'
import { Circle } from '../atoms'

type Props = {
  text: string
}

const TestimonialCard: FC<Props> = ({ text }) => {
  return (
    <Box
      display='flex'
      p={3}
      gap='12px'
      bgcolor='var(--alpha)'
      color='var(--omega)'
      borderRadius='16px'
      position='relative'
      lineHeight='120%'
      fontSize='20px'
      sx={{
        '@media (max-width: 1280px)': {
          fontSize: '16px',
          padding: '24px 14px 24px 20px'
        },
        '@media (max-width: 768px)': {
          padding: '20px 14px 20px 20px'
        },
        '@media (max-width: 480px)': {
          padding: '16px 9px 16px 16px',
          gap: '16px'
        }
      }}>
      <Circle />
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </Box>
  )
}

export default TestimonialCard
